import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  autocompleteRoot: {
    paddingTop: "0 !important",
  },
}))
export default styles
